module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "//fonts.googleapis.com/icon?family=Material+Icons"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../screen.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../extend-screen.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../main.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("型番一覧入力")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_vm._v("\n      型番 数量(空白区切り)\n      "), _c('span', {
    staticStyle: {
      "padding-left": "190px"
    }
  }, [_c('a', {
    staticClass: "link-right",
    staticStyle: {
      "color": "#3673ac"
    },
    attrs: {
      "href": "javascript:",
      "onmouseover": "this.style.color='#ff7f50'",
      "onmouseout": "this.style.color='#3673ac'"
    },
    on: {
      "click": _vm.goCheck
    }
  }, [_vm._v("確認")]), _vm._v(" "), (this.$props.debug) ? _c('a', {
    staticClass: "link-right",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.goSelect(false)
      }
    }
  }, [_vm._v("詳細選択へ")]) : _vm._e(), _vm._v(" "), (this.$props.debug) ? _c('a', {
    staticClass: "link-right",
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        _vm.goSelect(true)
      }
    }
  }, [_vm._v("インストール設定へ")]) : _vm._e()])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.koseiList),
      expression: "koseiList"
    }],
    attrs: {
      "name": "koseiList",
      "rows": "20",
      "cols": "50",
      "wrap": "off"
    },
    domProps: {
      "value": (_vm.koseiList)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.koseiList = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.serverError) ? _c('div', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.error || _vm.warning) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.warning) ? _c('a', {
    staticClass: "link-right",
    staticStyle: {
      "color": "#3673ac"
    },
    attrs: {
      "href": "javascript:",
      "onmouseover": "this.style.color='#ff7f50'",
      "onmouseout": "this.style.color='#3673ac'"
    },
    on: {
      "click": _vm.goNext
    }
  }, [_vm._v("次へ")]) : _vm._e()]), _vm._v(" "), (_vm.error) ? _c('dl', {
    staticClass: "error"
  }, [_c('dt', [_vm._v("構成にエラーがあります")]), _vm._v(" "), _c('dd', [_vm._v("もう一度型番をご確認の上入力してください。")])]) : _vm._e(), _vm._v(" "), (_vm.warning && !_vm.error) ? _c('dl', {
    staticClass: "warning"
  }, [_c('dt', [_vm._v("警告項目がありますのでご確認ください")]), _vm._v(" "), _c('dd', [_vm._v("メッセージ欄の内容をご確認の上「次へ」をクリックしてください")])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "border",
    attrs: {
      "width": "100%",
      "summary": ""
    }
  }, [_c('tbody', [_vm._m(2), _vm._v(" "), _vm._l((_vm.res), function(c, i) {
    return _c('tr', [_c('td', {
      class: (c.error_cd == 1) ? 'err-cell' : (c.error_cd == 2) ? 'war-cell' : null
    }, [_vm._v(_vm._s(c.koban))]), _vm._v(" "), _c('td', {
      class: (c.error_cd == 1) ? 'err-cell' : (c.error_cd == 2) ? 'war-cell' : null
    }, [_vm._v(_vm._s(c.hinmei_cd))]), _vm._v(" "), _c('td', {
      class: (c.error_cd == 1) ? 'err-cell' : (c.error_cd == 2) ? 'war-cell' : null
    }, [_vm._v(_vm._s(c.suryo))]), _vm._v(" "), _c('td', {
      class: (c.error_cd == 1) ? 'err-cell' : (c.error_cd == 2) ? 'war-cell' : null
    }, [_vm._v(_vm._s(c.kumikomi_koban))]), _vm._v(" "), _c('td', {
      class: (c.error_cd == 1) ? 'err-cell' : (c.error_cd == 2) ? 'war-cell' : null
    }, [_vm._v(_vm._s(c.kosei_id))]), _vm._v(" "), _c('td', {
      class: (c.error_cd == 1) ? 'err-cell' : (c.error_cd == 2) ? 'war-cell' : null
    }, [_vm._l((c.error_mes.split(/\t/)), function(m) {
      return [_vm._v("\n\t\t" + _vm._s(m) + " "), _c('br')]
    })], 2)])
  })], 2)])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "500px"
    }
  }, [_vm._v("※ 「必ず標準コンフィグレータで構成を組み、カートに入れてください」というエラーとなった製品は型番一覧入力からはカートに入れられません。標準コンフィグレータをお使いください\n    "), _c('br'), _vm._v("※カート導入後の構成編集は、下記製品のみ対応しております。\n    "), _c('ul', {
    staticStyle: {
      "margin": "0"
    }
  }, [_c('li', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_vm._v("ワークステーション")]), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_vm._v("PCサーバ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "error"
  }, [_c('dt', [_vm._v("通信エラーが発生しました")]), _vm._v(" "), _c('dd')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("項番")]), _vm._v(" "), _c('th', [_vm._v("型番")]), _vm._v(" "), _c('th', [_vm._v("数量")]), _vm._v(" "), _c('th', [_vm._v("組込項番")]), _vm._v(" "), _c('th', [_vm._v("カート項番")]), _vm._v(" "), _c('th', [_vm._v("メッセージ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "name": "goNext",
      "method": "POST",
      "action": "../CodeInput.action"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "kosei_id",
      "value": "1,1,1,1,1,1,1,1,1,1,1,1,1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "koban",
      "value": "1,2,3,4,5,6,7,8,9,10,11,12,13"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "kumikomi_koban",
      "value": "1,1,1,1,1,1,1,1,1,1,1,1,1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hinmei_cd",
      "value": "N8100-3004Y,K410-538(00),K410-E246(03),N8101-1873,N8102-764,N8103-218,N8103-243,N8116-116,N8150-1825,N8151-137,N8154-187,N8181-159,UL1908-00D1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "suryo",
      "value": "1,1,2,1,1,1,1,1,1,1,1,2,1"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "rkosei_cd",
      "value": ",,,,,,,,,,,,"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "para1",
      "value": ",,,,,,,,,,,,"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "para2",
      "value": ",,,,,,,,,,,,"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "para3",
      "value": ",,,,,,,,,,,,"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "sub_system",
      "value": ",,,,,,,,,,,,"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "config_flag",
      "value": "0,0,0,0,0,0,0,0,0,0,0,0,0"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "goSelect",
      "name": "goSelect",
      "method": "POST",
      "action": "../CodeSelect.action"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "base",
      "value": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5aff700a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CodeInput.vue
// module id = 455
// module chunks = 1